import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ServiceDetailLayout from "./ServiceDetailLayout";
import FaqItem from "./FaqItem";

const snapshot = {
  price: "a partir de 150 000 FCFA",
  delay: "7 a 14 jours",
  idealFor: "Restaurants, boutiques, prestataires, freelances",
};

const sections = [
  { id: "intro", label: "Ce qu'on fait" },
  { id: "pour-qui", label: "Pour qui ?" },
  { id: "fonctionnalites", label: "Ce qu'on inclut" },
  { id: "process", label: "Notre methode" },
  { id: "faq", label: "FAQ" },
];

export default function WebDetail() {
  return (
    <>
      <Helmet>
        <title>Sites Web & Applications Web — NEXUS SOLUTIONS</title>
        <meta name="description" content="Developpement de sites vitrines, landing pages et applications web sur mesure pour PME en Cote d'Ivoire. A partir de 150 000 FCFA. Livraison en 7 a 14 jours." />
        <meta property="og:title" content="Sites Web & Applications Web — NEXUS SOLUTIONS" />
        <meta property="og:description" content="Sites web et apps web sur mesure pour entrepreneurs ivoiriens. React, Node.js, responsive 3G, devis gratuit." />
      </Helmet>

      <ServiceDetailLayout title="Sites Web & Applications Web" summarySections={sections} snapshot={snapshot}>

        <section id="intro">
          <h2>Ce qu'on fait</h2>
          <p>
            Nous developpons des sites vitrines, landing pages et applications web
            pour les entrepreneurs et PME en Cote d'Ivoire. Chaque projet est cree
            sur mesure avec React et Node.js — pas de template generique.
          </p>
          <p>
            Un site vitrine simple peut etre livre en <strong>7 a 14 jours</strong>.
            Une application web complete (espace client, tableau de bord) prend
            generalement <strong>3 a 6 semaines</strong> selon la complexite.
          </p>
        </section>

        <section id="pour-qui">
          <h2>Pour qui ?</h2>
          <p>Un site web est utile a partir du moment ou vous voulez etre trouve et contacte en ligne.</p>
          <div className="for-who-grid">
            <div className="for-who-card">
              <span className="for-who-card__emoji">🍽</span>
              <div className="for-who-card__label">Restaurants & traiteurs</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">💇</span>
              <div className="for-who-card__label">Salons de beaute</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🏗</span>
              <div className="for-who-card__label">Artisans & BTP</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">💼</span>
              <div className="for-who-card__label">Consultants & freelances</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🏥</span>
              <div className="for-who-card__label">Cliniques & pharmacies</div>
            </div>
            <div className="for-who-card">
              <span className="for-who-card__emoji">🏫</span>
              <div className="for-who-card__label">Ecoles & formations</div>
            </div>
          </div>
        </section>

        <section id="fonctionnalites">
          <h2>Ce qu'on inclut</h2>
          <ul>
            <li>Design responsive — affichage parfait sur telephone, tablette et ordinateur</li>
            <li>Chargement rapide, meme sur connexion 3G</li>
            <li>Optimisation SEO de base pour etre trouve sur Google</li>
            <li>Formulaire de contact fonctionnel</li>
            <li>Integration WhatsApp, liens reseaux sociaux</li>
            <li>Hebergement et mise en ligne inclus la premiere annee</li>
          </ul>
        </section>

        <section id="process">
          <h2>Notre methode</h2>
          <ol>
            <li><strong>Echange (30 min)</strong> — On discute de vos besoins par appel ou WhatsApp. Gratuit, sans engagement.</li>
            <li><strong>Maquette</strong> — On vous montre la structure visuelle avant de coder. Vous validez.</li>
            <li><strong>Developpement</strong> — On code, vous validez a chaque etape importante.</li>
            <li><strong>Livraison & suivi</strong> — On met en ligne et on reste disponibles pour les corrections.</li>
          </ol>
        </section>

        <section id="faq">
          <h2>FAQ</h2>
          <FaqItem question="Combien ca coute exactement ?">
            Un site vitrine demarre a partir de 150 000 FCFA. Le prix varie selon le nombre de pages et les fonctionnalites. On vous donne un devis precis avant de commencer — aucune surprise sur la facture. Vous pouvez aussi consulter nos <Link to="/tarifs" style={{ color: '#4b004b' }}>formules et tarifs</Link>.
          </FaqItem>
          <FaqItem question="Vous pouvez maintenir mon site apres la livraison ?">
            Oui. On propose un suivi mensuel pour les mises a jour, corrections et evolutions. Tarif selon le besoin, discute en amont.
          </FaqItem>
          <FaqItem question="Je n'y connais rien en technique. C'est un probleme ?">
            Pas du tout. On explique tout en langage simple. Vous n'avez pas besoin de savoir coder pour travailler avec nous.
          </FaqItem>
          <FaqItem question="On peut payer en plusieurs fois ?">
            Oui. On pratique generalement un acompte de 50% au demarrage et le reste a la livraison. D'autres arrangements sont possibles selon le projet.
          </FaqItem>
          <FaqItem question="Mon site sera-t-il visible sur Google ?">
            On integre les bases du SEO (balises, vitesse, responsive) qui donnent une bonne base. Pour une strategie SEO avancee avec contenu regulier, on peut vous proposer un accompagnement mensuel.
          </FaqItem>

          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <Link
              to="/devis"
              style={{
                background: '#4b004b', color: '#fff', padding: '13px 36px',
                borderRadius: '28px', fontWeight: 700, textDecoration: 'none',
                fontSize: '1rem', display: 'inline-block',
              }}
            >
              Demander un devis gratuit
            </Link>
          </div>
        </section>

        <div className="related-services">
          <div className="related-services__title">Vous pourriez aussi avoir besoin de</div>
          <div className="related-services__grid">
            <Link to="/services/applications-mobiles" className="related-service-card">
              <span className="related-service-card__icon">📱</span>
              <div className="related-service-card__body">
                <div className="related-service-card__title">Application Mobile</div>
                <div className="related-service-card__desc">iOS & Android, React Native</div>
              </div>
              <span className="related-service-card__arrow">→</span>
            </Link>
            <Link to="/services/applications-e-commerce" className="related-service-card">
              <span className="related-service-card__icon">🛒</span>
              <div className="related-service-card__body">
                <div className="related-service-card__title">E-commerce</div>
                <div className="related-service-card__desc">Orange Money & Wave integres</div>
              </div>
              <span className="related-service-card__arrow">→</span>
            </Link>
          </div>
        </div>

      </ServiceDetailLayout>
    </>
  );
}
